import { render, staticRenderFns } from "./profilecontent.vue?vue&type=template&id=95f5746c"
import script from "./profilecontent.vue?vue&type=script&lang=js"
export * from "./profilecontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports